module.exports = __webpack_public_path__ + "SamsungOne-450C.ae1bcc9241d862e8c0f7.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-450C.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-450C.ttf
// module chunks = styles